var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filters-bar"},_vm._l((_vm.options),function(option){return _c('div',{staticClass:"filters-bar__item"},[(option.type === 'select')?_c('FormSelect',{attrs:{"name":option.name,"label":option.label ? option.label : '',"value":option.value,"options":option.options,"onChange":_vm.onChange}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }